export { default } from './svg/arrow-right.svg';
